import authReducer from "./authentication/authSlice";
import brandViewer from "./brandViewer/brandViewer";
import modelGlasses from "./brandViewer/modelGlasses";
import sidebarReducer from "./sidebar";
import modelReducer from "./model/reducer";

const reducers = {
  auth: authReducer,
  brandViewer,
  modelGlasses,
  sidebar: sidebarReducer,
  model: modelReducer,
};

export default reducers;